import { render, staticRenderFns } from "./AppSelectField.vue?vue&type=template&id=d54acba0"
import script from "./AppSelectField.vue?vue&type=script&lang=js"
export * from "./AppSelectField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports